export default __webpack_public_path__ + "static/media/bl1.c6a6df25.png";